import {
  ILogger,
  IDevice,
  BaseCoreFactory,
  ICoreFactory,
  SoloLogger,
  SessionManager,
  RegionResolver,
  SoloNativeRTCChannel,
  SoloNativeRTCHandler,
  ICobranding,
  IRTCChannel,
  WebViewPlatformDevice,
} from '@amzn/work-spaces-web-client-core-lib';
import { HttpClientFactory } from '../HttpClientFactory';

export abstract class SoloCoreFactory
  extends BaseCoreFactory
  implements ICoreFactory
{
  protected _rtcChannel?: IRTCChannel;
  protected _regionResolver?: RegionResolver;
  abstract getCobranding(): ICobranding;

  getHttpClientFactory() {
    return HttpClientFactory;
  }

  createSessionManager() {
    return new SessionManager(
      this.getSessionStorage(),
      this.getPersistentStorage()
    );
  }

  getDevice(): IDevice {
    if (!this._device) {
      this._device = new WebViewPlatformDevice();
    }
    return this._device;
  }

  getLogger(): ILogger {
    if (!this._logger) {
      const device = this.getDevice();
      this._logger = new SoloLogger(device);
    }
    return this._logger;
  }

  getRTCChannel(): IRTCChannel | null {
    if (!this._rtcChannel) {
      const logger = this.getLogger();
      const metrics = this.getMetrics();
      const sessionManager = this.getSessionManager();
      const handler = new SoloNativeRTCHandler(logger, metrics, sessionManager);
      this._rtcChannel = new SoloNativeRTCChannel(logger, handler);
    }
    return this._rtcChannel;
  }

  getRegionResolver() {
    if (this._regionResolver == null) {
      this._regionResolver = new RegionResolver(
        this.getLogger(),
        this.getMetrics(),
        HttpClientFactory.getHttpClient(),
        this.getRTCChannel()
      );
    }
    return this._regionResolver;
  }
}
